import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { JobSitesService } from 'src/app/lmo/services/job-sites.service';
import { LMOSiteSummary } from '~proto/site/site_pb';
import { trackById } from '~utilities/trackById';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'ct-jobs-home-recent',
  styleUrls: ['./jobs-home-recent.component.scss'],
  templateUrl: './jobs-home-recent.component.html',
})
export class JobsHomeRecentComponent implements OnInit {
  public trackById = trackById;
  public recentJobs$: Observable<LMOSiteSummary.AsObject[]>;

  constructor(private jobs: JobSitesService) {}

  public ngOnInit() {
    this.recentJobs$ = this.jobs.unpinnedSites$;
  }
}
